module.exports = __webpack_public_path__ + "img/element-icons-30-x-30-ic-detail-schd-off.2b6fe70f.svg";